import { monthNameLong } from '@mnd-frontend/dates';
import { BrandReportTimespan } from '@mnd-frontend/graphql-schema';
import { timeSpanString } from '../components/common';
import type { TranslationFunction } from '../types';

export const getLegendCaptionString = ({
  t,
  locale,
  fromDate,
  toDate,
  timezone,
  timespan,
}: {
  fromDate: Date;
  toDate: Date;
  t: TranslationFunction;
  timespan: BrandReportTimespan;
  timezone: string;
  locale: string;
}) => {
  switch (timespan) {
    case BrandReportTimespan.LastHalfYear:
      return t('reports_last_half_year_period', {
        period: fromDate.getMonth() > 5 ? 2 : 1,
        year: fromDate.getFullYear(),
      });
    case BrandReportTimespan.LastQuarter:
      return t('reports_last_quarter_period', {
        period: Math.ceil((fromDate.getMonth() + 1) / 3),
        year: fromDate.getFullYear(),
      });
    case BrandReportTimespan.LastMonth:
      return monthNameLong(fromDate, locale);
    case BrandReportTimespan.LastYear:
      return fromDate.getFullYear().toString();
    default:
      return timeSpanString({ fromDate, toDate, timezone, locale });
  }
};
